module.exports = __webpack_public_path__ + "img/introducePageSeven_show_three.3b26d516.jpg";